import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

/**
 * Shared admin add/edit modal shell: header (title, subtitle, optional actions), scrollable body, optional footer.
 */
export default function AdminFormModal({
  isOpen,
  toggle,
  title,
  subtitle,
  actions = null,
  size = "lg",
  footer = null,
  children,
  scrollable = true,
  className = "modal-dialog-centered",
}) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size={size} className={className} scrollable={scrollable}>
      <ModalHeader toggle={toggle}>
        <div className="w-100 d-flex flex-wrap justify-content-between align-items-start flex-g-2 pe-sm-2">
          <div className="min-w-0 flex-grow-1 me-2">
            <h5 className="title mb-0 text-break">{title}</h5>
            {subtitle ? <p className="text-soft small mb-0 mt-1">{subtitle}</p> : null}
          </div>
          {actions ? <div className="d-flex flex-wrap flex-g-2 flex-shrink-0 align-items-center">{actions}</div> : null}
        </div>
      </ModalHeader>
      <ModalBody className="pt-2 position-relative">{children}</ModalBody>
      {footer != null ? (
        <ModalFooter className="border-top bg-lighter justify-content-between flex-wrap flex-g-2">{footer}</ModalFooter>
      ) : null}
    </Modal>
  );
}
